import { handleRPCError } from "../utils/helpers";
import web3 from "./web3Service";

export default class BaseContractService {
  constructor(contractAddress, abi) {
    this.contract = new web3.eth.Contract(abi, contractAddress);
  }

  async estimateGas(action, options) {
    const gas = await action
      .estimateGas(options)
      .then((e) => e)
      .catch((e) => {
        console.log(handleRPCError(e));
        if (e.message.includes("insufficient funds"))
          throw { message: "Insufficient funds" };
        if (e.message.includes("User denied transaction signature"))
          throw { message: "Transaction canceled" };
        if (e.message.includes("sale is not active"))
          throw { message: "Sale has not started" };
        throw { message: handleRPCError(e) };
      });
    options = { ...options, gas: parseInt(1.2 * gas) };
    return action.send(options);
  }
}
